export default "/images/vendor/flag-icon-css/flags/1x1/bh.svg?0cfc56195412f09f4c705d519df5972c";